export default __webpack_public_path__ + "static/media/3.49d7682c.jpeg";